import { FC } from 'react';
import { ProButton } from '../antd';
import { BaseOperationButtonProps } from './interface';
import { ICON_COLLECTION } from '../constants/icon';

/** 批量操作按钮 */
const BatchButton: FC<BaseOperationButtonProps> = props => {
  const { children, text, icon, ...restProps } = props;
  return (
    <ProButton icon={icon} {...restProps}>
      {children || text}
    </ProButton>
  );
};

BatchButton.defaultProps = {
  icon: ICON_COLLECTION.BATCH,
  text: '批量操作',
};

export default BatchButton;
